import { QuotationData } from '../../models/Quotations';

const useQuotations = () => {
    const createData = (
        quoteID: string,
        billToCustomerName: string,
        orderDate: string,
        count: number
    ): QuotationData => {
        return {
            quoteID,
            billToCustomerName,
            orderDate,
            count,
        };
    };
    const getQuotations = () => {
        return [
            createData('122232222', 'Kiss János', '2021.12.20', 3),
            createData('12223222244', 'Török Annamária', '2021.12.20', 2),
        ];
    };

    const copyQuotation = (quoteId) => {};

    const deleteQuotation = (quoteId) => {};

    const createPDFQuotation = (quote) => {};

    const fakePromise = () => {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };

    return {
        getQuotations,
        copyQuotation,
        deleteQuotation,
        createPDFQuotation,
        fakePromise
    };
};

export default useQuotations;
